module.exports = __webpack_public_path__ + "img/ck-ranking+0.e3f428aa.png";